import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const AUTO_SCALING_STORAGE_KEY = 'autoScalingEnabled';

const autoScalingStorage = createJSONStorage<boolean>(() => localStorage);

export const autoScalingEnabledAtom = atomWithStorage<boolean>(
  AUTO_SCALING_STORAGE_KEY,
  true,
  autoScalingStorage,
  { getOnInit: true },
);
